module.exports = __webpack_public_path__ + "static/video 1-8d726a1bf44f41494c0f3da9b0a71322.jpg";